import React from "react";
import { Col, Image, Row, Container } from "react-bootstrap";
import { SchoolMemberData } from "../../db/SchoolMemberData";
import "./MembersProgram.css";
import { Link } from "react-router-dom";

function MembersList() {
  return (
    <div>
      <Container className="py-5">
        <Row>
          {SchoolMemberData.map((item, index) => {
            return (
              <Col xs={12} md={4} lg={3} key={item.id}>
                <a href="#">
                  <div className="partner_card">
                    <Link to={item.path}>
                      <div className="image-adjuster">
                        <Image src={item.logo} fluid />
                      </div>
                      <h5>{item.institution}</h5>
                    </Link>
                  </div>
                </a>
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
  );
}

export default MembersList;
